export class OnboardingModel {
  detail: any;
  partners: [];
  staff: [];
  clients: [];
  invitee: [];
}
